export default "__VITE_ASSET__Hrn_oZ5B__"